"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var index_1 = __importDefault(require("../DateIntervalInputPicker/index"));
var index_2 = __importDefault(require("../FilterConfirm/index"));
var DateRangeFilterConfirm = /** @class */ (function (_super) {
    __extends(DateRangeFilterConfirm, _super);
    function DateRangeFilterConfirm(props) {
        var _this = _super.call(this, props) || this;
        _this.onIntervalChange = function (interval) {
            _this.setState({
                from: interval.from,
                to: interval.to,
            });
        };
        _this.onConfirmClick = function () {
            _this.props.onChange(_this.state.from, _this.state.to);
        };
        _this.onResetClick = function () {
            _this.setState({
                from: undefined,
                to: undefined,
            });
            _this.props.onChange(undefined, undefined);
        };
        _this.state = {
            from: props.from,
            to: props.to,
        };
        return _this;
    }
    DateRangeFilterConfirm.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.from !== prevState.prevPropsFrom || nextProps.to !== prevState.prevPropsTo) {
            return {
                from: nextProps.from,
                to: nextProps.to,
                prevPropsFrom: nextProps.from,
                prevPropsTo: nextProps.to,
            };
        }
        return null;
    };
    DateRangeFilterConfirm.prototype.render = function () {
        return (react_1.default.createElement(index_2.default, { onConfirmClick: this.onConfirmClick, onResetClick: this.onResetClick },
            react_1.default.createElement(index_1.default, { onChange: this.onIntervalChange, numberOfMonths: 1, from: this.state.from, to: this.state.to })));
    };
    return DateRangeFilterConfirm;
}(react_1.default.Component));
exports.default = DateRangeFilterConfirm;
//# sourceMappingURL=index.js.map